import { render, staticRenderFns } from "./ZnMarketMoney.vue?vue&type=template&id=1fd04521"
import script from "./ZnMarketMoney.vue?vue&type=script&lang=js"
export * from "./ZnMarketMoney.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports